
export class FacturaDetalle {
    
  
    id:number;
    descripcion:string;
    cantidad:number;
    precioUnitario:number;
    descuento:number;
    precioTotalSinImpuestos:number;
    idProducto:number;
    idUnidad:number;
    factor:number;
    valorIva:number;
    enviado:string;
    costo:number;
    }
    